/**
 * SaveButton Component
 *
 * Manual save button for steps
 * Shows between Back and Next buttons
 */

import { useForm } from '../../contexts/FormContext'
import Button from './Button'

function SaveButton() {
  const { manualSave } = useForm()

  return (
    <Button variant="ghost" size="md" onClick={manualSave}>
      💾 Save Progress
    </Button>
  )
}

export default SaveButton
